import './../css/base.css';
import './../css/custom.css';
import './../css/profile.css';

import {HashLink} from 'react-router-hash-link';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faBuildingColumns, faEnvelope, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

library.add(faLink, faBuildingColumns, faEnvelope, faUpRightFromSquare);

const Profile = () => {
  return (
    <div className="window-wrapper">
      <div className="content-wrapper">
        <div className = "prof-box">
        </div>
        </div>
    </div>
  );
};

export default Profile;